var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgBannerPlay = function SvgBannerPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 62"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 31,
    cy: 31,
    r: 31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.015 48c-.145 0-.29 0-.435-.076-.362-.152-.58-.531-.58-.986V15.065c0-.455.218-.834.58-.986a1.114 1.114 0 011.088.152l16.97 15.936c.217.227.362.531.362.835 0 .303-.145.607-.363.834l-16.97 15.86c-.217.228-.434.304-.652.304zm1.016-30.506v27.015l14.358-13.507-14.358-13.508z",
    fillRule: "nonzero",
    stroke: "currentColor",
    fill: "currentColor"
  }))));
};
export default SvgBannerPlay;